export const GROUP_TO_GROUP = 'orders-groups-change-group/GROUP_TO_GROUP';
export const groupToGroupAction = payload => ({
	type: GROUP_TO_GROUP,
	payload,
});

export const WAY_TO_GROUP = 'orders-groups-change-group/WAY_TO_GROUP';
export const wayToGroupAction = payload => ({
	type: WAY_TO_GROUP,
	payload,
});

export const ORDER_GROUP_TO_GROUP = 'orders-groups-change-group/ORDER_GROUP_TO_GROUP';
export const orderGroupToGroupAction = payload => ({
	type: ORDER_GROUP_TO_GROUP,
	payload,
});

export const ORDER_WAY_TO_GROUP = 'orders-groups-change-group/ORDER_WAY_TO_GROUP';
export const orderWayToGroupAction = payload => ({
	type: ORDER_WAY_TO_GROUP,
	payload,
});
